import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./styles.scss";

export const Merch = (): JSX.Element => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="merch">
      <h1>Merch</h1>
      <h2>Coming soon</h2>
      <h3>
        Yes, we know...
        <br />
        Finally!
      </h3>
    </div>
  );
};
